
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaiairportinnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Airport Innova Crysta',
        heading: 'Meghana Cab : Pune to Mumbai Airport Innova Crysta',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Airport Innova Crysta service, delivering a premium, comfortable, and convenient travel experience for airport transfers. Whether you are catching an international flight or returning from a domestic journey, our Innova Crysta vehicles offer luxe leather interiors, spacious seating, and generous luggage capacity—perfect for travelers and families. Benefit from professional chauffeurs who monitor your flight for delays, prompt door-to-door pickups, real-time GPS tracking, and transparent fixed fares. With 24/7 customer support and hassle-free payment options, your journey to Mumbai International Airport is smooth and stress-free. Book your Pune to Mumbai Airport Innova Crysta with Meghana Cab and arrive refreshed, timely, and in style.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 to commemorate the visit of King George V and Queen Mary, the Gateway of India is Mumbai’s most iconic monument. Overlooking the Arabian Sea, this basalt arch combines Indo-Saracenic and Muslim architectural styles. It served as a ceremonial entrance to colonial India and later as the symbolic site where British troops departed post-independence. Today, it's a popular tourist attraction and ferry departure point to Elephanta Caves, surrounded by street vendors, photographers, and historic landmarks like the Taj Mahal Palace Hotel."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace for its crescent-shaped illumination at night, is a 3.6-kilometer promenade along the Arabian Sea. A favorite spot for locals and tourists alike, it offers stunning sunset views, cool sea breezes, and a chance to observe Mumbai’s daily rhythm. The adjacent Chowpatty Beach is known for its lively street food scene. Whether for a leisurely walk, jog, or just a moment of serenity, Marine Drive captures the soul of Mumbai’s coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site and functional railway hub, CST is a stunning example of Victorian Gothic architecture infused with Indian elements. Built in 1887, its façade features turrets, pointed arches, and stained-glass windows, while the interior buzzes with daily commuters. It’s not just a transport terminal but a testament to Mumbai’s colonial past and architectural grandeur. Night lighting accentuates its beauty, making it a must-see for architecture enthusiasts and photographers."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, about an hour’s ferry ride from the Gateway of India, these UNESCO World Heritage rock-cut caves date back to the 5th to 8th centuries. The main cave is dedicated to Lord Shiva and features the magnificent 20-foot Trimurti sculpture. The caves reflect a rich blend of art, religion, and ancient Indian craftsmanship. Surrounded by natural beauty, the island offers panoramic views, walking trails, and historical significance—perfect for a day trip from the city."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple in Prabhadevi is one of the most visited and revered temples in Maharashtra. Built in 1801, the temple’s sanctum houses a unique black stone idol of Ganesha with a tilted trunk. The gold-plated dome and inner sanctum attract thousands of devotees, especially on Tuesdays. Bollywood stars and politicians are frequent visitors. The temple is well-organized, offering online darshan, prasadam counters, and a deeply spiritual atmosphere in the heart of the city."
  },
  {
    "title": "Juhu Beach",
    "description": "Stretching along Mumbai’s western coastline, Juhu Beach is famous for its lively ambiance, local snacks like pav bhaji and sev puri, and sunset views. The beach is a favorite hangout for families, joggers, and street performers. It’s located near the homes of several Bollywood celebrities, adding a touch of glamor to its appeal. During festivals like Ganesh Visarjan, the beach transforms into a colorful and spiritual hub with thousands gathering to witness idol immersions."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most famous shopping street, filled with stalls offering clothes, antiques, jewelry, books, and souvenirs. It also hosts iconic landmarks like Leopold Café and Café Mondegar, both rich in history and popular among travelers. The area reflects the city’s cosmopolitan culture, blending colonial architecture, street fashion, and vibrant energy. A walk down Colaba is an immersive experience for anyone wanting to explore Mumbai’s urban essence and vintage charm."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Floating off the coast of Worli, Haji Ali Dargah is a 15th-century Indo-Islamic mosque and tomb built in memory of the saint Haji Ali. Connected by a 500-meter causeway that submerges during high tide, the shrine is visited by people of all faiths. The white domes, marble interiors, and soothing devotional music create a spiritual retreat amidst the sea. It is both a religious site and a symbol of Mumbai’s inclusive cultural fabric."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Located in the northern part of Mumbai, this sprawling national park covers over 100 square kilometers and is one of the world’s only national parks within city limits. It’s home to leopards, deer, butterflies, and hundreds of bird species. Inside the park lie the ancient Kanheri Caves—over 100 Buddhist rock-cut caves dating back 2,000 years. Ideal for nature walks, safaris, and spiritual retreats, this park offers an oasis of calm away from Mumbai’s urban pace."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic structure, this museum features over 50,000 artifacts ranging from miniature paintings and decorative arts to ancient sculptures and arms. Located in South Mumbai near the Gateway of India, it offers curated galleries on Indian history, archaeology, natural history, and European art. Its beautifully landscaped garden and architectural grandeur make it a peaceful and educational escape for culture seekers."
  }
],

"services": [
  {
    "name": "Pune to Mumbai Airport Innova Crysta Cab",
    "description": "Travel comfortably from Pune to Mumbai Airport with our premium Innova Crysta cab service. Perfect for business travelers and families alike, enjoy spacious seating, ample luggage space, and a smooth ride with professional chauffeurs ensuring timely arrival."
  },
  {
    "name": "One Way Innova Crysta Pune to Mumbai Airport",
    "description": "Book a convenient one-way Innova Crysta taxi from Pune to Mumbai Airport for hassle-free transfers. Ideal for solo travelers or quick trips, this service guarantees punctual pickups and a comfortable journey with climate-controlled interiors."
  },
  {
    "name": "Round Trip Pune Mumbai Airport Innova Crysta",
    "description": "Plan your round trip from Pune to Mumbai Airport and back with our reliable Innova Crysta cab service. Perfect for frequent flyers and corporate clients, enjoy flexible scheduling, premium comfort, and courteous chauffeurs dedicated to your travel needs."
  },
  {
    "name": "AC Innova Crysta Taxi Pune to Mumbai Airport",
    "description": "Beat the heat with our fully air-conditioned Innova Crysta taxi from Pune to Mumbai Airport. Experience a refreshing and smooth ride with plush interiors and climate control, making your airport transfer comfortable and stress-free."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Mumbai Airport",
    "description": "Sit back and relax as our professional chauffeurs drive you from Pune to Mumbai Airport in a top-notch Innova Crysta. We prioritize safety, punctuality, and excellent service to ensure a seamless travel experience."
  },
  {
    "name": "Private Innova Crysta Cab Pune to Mumbai Airport",
    "description": "Enjoy exclusive travel with our private Innova Crysta cab service from Pune to Mumbai Airport. Tailored for VIPs and travelers seeking privacy, this service offers dedicated vehicles and personalized attention throughout your journey."
  },
  {
    "name": "Online Booking Innova Crysta Taxi Pune Mumbai Airport",
    "description": "Book your Pune to Mumbai Airport Innova Crysta taxi online with ease. Our user-friendly platform provides instant confirmation, secure payments, and flexible timing options to suit your busy schedule."
  },
  {
    "name": "Family Innova Crysta Pune to Mumbai Airport",
    "description": "Travel comfortably with your family from Pune to Mumbai Airport in our spacious Innova Crysta cab. With ample legroom and luggage space, our service ensures a smooth, safe, and enjoyable ride for all family members."
  }
],
"tableData": [
  ["Pune to Mumbai Airport Innova Crysta Cab", "One Way Innova Crysta Pune to Mumbai Airport"],
  ["Round Trip Pune Mumbai Airport Innova Crysta", "AC Innova Crysta Taxi Pune to Mumbai Airport"],
  ["Chauffeur Driven Innova Crysta Pune to Mumbai Airport", "Private Innova Crysta Cab Pune to Mumbai Airport"],
  ["Online Booking Innova Crysta Taxi Pune Mumbai Airport", "Family Innova Crysta Pune to Mumbai Airport"]
],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Mumbai Airport Innova Crysta Service",
        "WhyChoosedescription": "Travel from Pune to Mumbai Airport in a premium Innova Crysta cab that combines space, comfort, and style. Perfect for business travelers, families, and groups, our service ensures a smooth and hassle-free airport transfer experience."
    },
    {
        "WhyChooseheading": "Spacious Interiors with Ample Luggage Space",
        "WhyChoosedescription": "The Innova Crysta offers comfortable seating for up to 6-7 passengers along with generous luggage capacity, making it ideal for airport transfers with multiple bags and equipment."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Airport Routes",
        "WhyChoosedescription": "Our professional drivers are well-acquainted with the best routes to Mumbai Airport, traffic patterns, and drop-off procedures, ensuring timely arrivals and stress-free journeys."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Each Innova Crysta in our fleet undergoes regular maintenance and thorough sanitization before every trip, guaranteeing a clean and safe environment for your airport transfer."
    },
    {
        "WhyChooseheading": "Flexible Booking with Real-Time Flight Monitoring",
        "WhyChoosedescription": "Book your cab with confidence and enjoy real-time flight tracking updates that allow us to adjust pickup times according to your flight schedule, minimizing wait times and delays."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Our pricing is all-inclusive, covering tolls, taxes, driver allowances, and fuel charges. Enjoy upfront rates with no surprises, offering excellent value for your airport transfer."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Our customer care team is available round the clock to assist you with bookings, itinerary changes, or special requests, ensuring a smooth and hassle-free service experience."
    },
    {
        "WhyChooseheading": "Ideal for Business and Leisure Travelers",
        "WhyChoosedescription": "Whether you’re heading to catch a flight or arriving from Mumbai, our Innova Crysta cabs provide a premium travel experience with comfort, professionalism, and reliability."
    }
]



















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta from Pune to Mumbai Airport?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or through our website for instant booking."
    },
    {
        question: "Is Innova Crysta available for one way trips to Mumbai Airport?",
        answer: "Yes, we offer one way Innova Crysta cabs from Pune to Chhatrapati Shivaji Maharaj International Airport, Mumbai."
    },
    {
        question: "What is the travel time from Pune to Mumbai Airport by Innova Crysta?",
        answer: "The journey usually takes around 3.5 to 4.5 hours, depending on traffic and road conditions."
    },
    {
        question: "How many passengers can travel in an Innova Crysta?",
        answer: "Innova Crysta comfortably accommodates 6 to 7 passengers along with ample luggage space."
    },
    {
        question: "Is the Pune to Mumbai Airport Innova Crysta service available 24/7?",
        answer: "Yes, we provide 24/7 service to match your flight schedule, including early morning and late night pickups."
    },
    {
        question: "Are the drivers experienced and reliable for airport transfers?",
        answer: "Yes, our drivers are professional, punctual, and experienced in long-distance airport routes."
    },
    {
        question: "What does the fare include for Pune to Mumbai Airport Innova Crysta?",
        answer: "The fare includes fuel, tolls, and driver charges. Waiting time or parking fees may be extra if applicable."
    },
    {
        question: "Can I make stops during the trip to Mumbai Airport?",
        answer: "Yes, short halts can be arranged on request. Please inform us in advance while booking."
    },
    {
        question: "Are the Innova Crysta cabs sanitized before each ride?",
        answer: "Yes, every vehicle is thoroughly sanitized and maintained for your safety and hygiene."
    },
    {
        question: "What payment options are available for booking?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Abhishek More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service from Pune to Mumbai Airport in an Innova Crysta. Clean car, on-time pickup, and smooth ride.”',
    },
    {
        name: 'Ms. Leena Gokhale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Hassle-free and comfortable airport drop with Meghana Cab. The Innova Crysta was perfect for our family trip.”',
    },
];









































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneMumbaiAirportSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mumbai Airport Innova Crysta Cab Service",
  "description": "Book AC Innova Crysta cabs for comfortable Pune to Mumbai Airport transfers. Chauffeur-driven, private, and family-friendly taxi service with easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Airport Transfer Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Mumbai"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-airport-innova-crysta-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Airport Innova Crysta Cab | Meghana Cabs</title>
  <meta
    name="description"
    content="Reliable AC Innova Crysta taxi from Pune to Mumbai Airport. One way and round trip options. Chauffeur-driven, private & family-friendly service with online booking."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Innova Crysta Cab, One Way Innova Crysta Pune to Mumbai Airport, Round Trip Pune Mumbai Airport Innova Crysta, AC Innova Crysta Taxi Pune to Mumbai Airport, Chauffeur Driven Innova Crysta Pune to Mumbai Airport, Private Innova Crysta Cab Pune to Mumbai Airport, Online Booking Innova Crysta Taxi Pune Mumbai Airport, Family Innova Crysta Pune to Mumbai Airport"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneMumbaiAirportSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiairportinnovacrysta;